import "dayjs/locale/fr";

import { useContext } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { RouterProvider } from "react-router-dom";

import { AuthContext } from "@/contexts/auth-context";
import { router, routerNotAuthenticated } from "@/routes/router";
import { SubscriptionStatus } from "@/types/api/user";

dayjs.locale("fr");
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);

function App() {
  const { isAuthenticated, user } = useContext(AuthContext);

  return (
    <RouterProvider
      router={
        isAuthenticated &&
        user?.subscriptionStatus === SubscriptionStatus.ACTIVE
          ? router
          : routerNotAuthenticated
      }
    />
  );
}

export default App;
